import appConstants from "../../../../../appConstants";
import { StaticFilter, MultiSelectFilter } from '@dataGrid/components/columnFilters';
import CommandCellRenderer from '@dataGrid/components/cellRenderer/CommandCellRenderer';

export default class GridConfig {
  constructor(configuration) {
    const config = configuration || {};
    this.name = "GridConfiguration";
    this.config = GridConfig.getConfiguration(config);
  }
  static getConfiguration({ terminalAccessLabel }) {
    return GridConfig.getDefaultConfiguration({ terminalAccessLabel });
  }

  static getCommandCellRenderer = (params) => {
    const commandConfig = {
      editCommand: "editFeederTerminal",
      editTitle: "Update Feeder Terminal",
      deleteCommand: "deleteFeederTerminal",
      deleteTitle: "Delete Feeder Terminal",
    };
    return <CommandCellRenderer commandConfig={commandConfig} params={{ ...params }} />;
  };

  static getStaticOptions = (params) => {
    const allRows = [];
    params.api.forEachNode((node) => {
      allRows.push(...(node.data?.feederTerminalCode || []));
    });
    const uniqueTerminals = [...new Set(allRows)];
    return uniqueTerminals.map((terminalCode) => ({
      value: terminalCode,
      text: terminalCode,
    }));
  };

  static getDefaultConfiguration() {
    return {
      title: appConstants.gridNames.FeederTerminal,
      keyColumn: "terminalCode",
      rowSelection: "single",
      defaultColDef: {
        filter: MultiSelectFilter
      },
      columns: [
        {
          headerName: "Terminal",
          field: "terminalCode",
          headerTooltip: "Terminal",
          minWidth: appConstants.columnWidth.TERMINAL,
          maxWidth: appConstants.columnWidth.TERMINAL,
        },
        {
          headerName: "Feeder Terminal",
          headerTooltip: "Feeder Terminal",
          minWidth: appConstants.columnWidth.FEEDER_TERMINAL,
          valueGetter: (params) => {
            return params.data.feederTerminalCode || [];
          },
          filter: StaticFilter,
          filterParams: {
            getStaticOptions: GridConfig.getStaticOptions,
          },
          tooltipValueGetter: (params) => params.value,
        },
        {
          headerName: "Region",
          headerTooltip: "Region",
          field: "regionName",
          minWidth: appConstants.columnWidth.REGION,
          maxWidth: appConstants.columnWidth.REGION,
          tooltipField: "regionName",
        },
        {
          headerName: "Division",
          headerTooltip: "Division",
          field: "divisionName",
          minWidth: appConstants.columnWidth.DIVISION,
          maxWidth: appConstants.columnWidth.DIVISION,
          tooltipField: "divisionName",
        },
        {
          headerName: "Action",
          headerTooltip: "Action",
          field: "action",
          cellRenderer: GridConfig.getCommandCellRenderer,
          minWidth: appConstants.columnWidth.ACTION,
          maxWidth: appConstants.columnWidth.ACTION,
          filter: false,
        },
      ],
    };
  }
}
